/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_Type_ConsumerInputs */

const vi_order_form_invoice_buyer_type_consumer = /** @type {(inputs: Order_Form_Invoice_Buyer_Type_ConsumerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người tiêu dùng`)
};

/**

* @param {Order_Form_Invoice_Buyer_Type_ConsumerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_type_consumer = /** @type {((inputs?: Order_Form_Invoice_Buyer_Type_ConsumerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_Type_ConsumerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_type_consumer(inputs)
});